/**
 * The walk over a glTF asset's surface materials that every per-surface rule shares: the
 * importer's sidecar corrections, the per-consumer clone and its disposal.
 */
/**
 * One node's material slot or slots. Gated on the slot, not on `isMesh`, because a glTF's
 * non-triangle primitives arrive as `Points`/`Line` with a material the importer's
 * per-surface rules reach too.
 */
function slotsOfNode(node) {
    // The classes that draw a material: a mesh and its skinned and instanced selves, a glTF's points and lines, a sprite.
    const drawn = node;
    const slot = drawn.material;
    if (!slot)
        return [];
    if (Array.isArray(slot)) {
        return slot.map((_, index) => ({
            holder: node,
            index,
            count: slot.length,
            assign: (replacement) => {
                slot[index] = replacement;
            },
            read: () => slot[index],
        }));
    }
    return [
        {
            holder: node,
            index: 0,
            count: 1,
            assign: (replacement) => {
                drawn.material = replacement;
            },
            read: () => drawn.material,
        },
    ];
}
/** Visit every surface material under `object`, with the setter for its own slot. */
export function forEachSurfaceMaterial(object, visit) {
    for (const slot of surfaceSlotsUnder(object)) {
        const material = slot.read();
        if (material === undefined)
            continue;
        visit(material, slot.assign, slot.read);
    }
}
/**
 * Every surface material slot under `object`, with its own holder, in
 * `forEachSurfaceMaterial`'s reach order; a holder with several surfaces appears once
 * per slot. A caller that pairs draws with the slot they cover, instead of visiting the
 * materials, needs this shape.
 *
 * @canonical The surface material slots under an object
 */
export function surfaceSlotsUnder(object) {
    const slots = [];
    object.traverse((node) => slots.push(...slotsOfNode(node)));
    return slots;
}
//# sourceMappingURL=surfaceMaterials.js.map